export function DeleteAccountPage() {
  const supportEmail = 'support@pxtenergies.com';
  const mailtoSubject = encodeURIComponent('Account Deletion Request');
  const mailtoBody = encodeURIComponent(
    'I would like to request deletion of my EVeeBuddy account.\n\n' +
      'Registered email: \n' +
      'Registered phone number: \n\n' +
      'I understand that transaction and invoice records will be retained as required by Indian tax law.',
  );

  return (
    <div className="min-h-dvh bg-gray-50 text-gray-900 antialiased">
      <main className="mx-auto max-w-2xl px-5 pt-[max(2.5rem,env(safe-area-inset-top))] pb-10 sm:pt-14 sm:pb-14">
        <header className="mb-8">
          <p className="text-sm font-medium uppercase tracking-wide text-[#8bc43e]">EVeeBuddy</p>
          <h1 className="mt-2 text-3xl font-semibold tracking-tight sm:text-4xl">
            Delete your account
          </h1>
          <p className="mt-3 text-sm text-gray-600">
            EVeeBuddy is operated by Pxt Energies Pvt Ltd. This page explains how to request
            deletion of your EVeeBuddy account and what happens to your data.
          </p>
        </header>

        <section className="mb-10 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <h2 className="text-lg font-semibold">How to request deletion</h2>
          <p className="mt-2 text-sm text-gray-600">
            You can delete your account in two ways:
          </p>

          <div className="mt-5 space-y-5">
            <div>
              <h3 className="text-sm font-semibold">1. From inside the app</h3>
              <ol className="mt-2 list-decimal space-y-1 pl-5 text-sm text-gray-700">
                <li>Open the EVeeBuddy app and sign in.</li>
                <li>Go to <span className="font-medium">Profile</span> (bottom navigation).</li>
                <li>Scroll down and tap <span className="font-medium">Delete Account</span>.</li>
                <li>Confirm the action in the dialog.</li>
              </ol>
            </div>

            <div className="border-t border-gray-100 pt-5">
              <h3 className="text-sm font-semibold">2. By email</h3>
              <p className="mt-2 text-sm text-gray-700">
                If you cannot access the app, email us from the address registered on your
                account:
              </p>
              <a
                href={`mailto:${supportEmail}?subject=${mailtoSubject}&body=${mailtoBody}`}
                className="mt-3 inline-flex items-center rounded-lg bg-[#8bc43e] px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-[#7ab030]"
              >
                Email {supportEmail}
              </a>
              <p className="mt-3 text-xs text-gray-500">
                Please send the request from your registered email and include your registered
                phone number so we can verify your identity. We will action verified requests
                within 7 business days.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-10 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <h2 className="text-lg font-semibold">What gets deleted</h2>
          <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm text-gray-700">
            <li>Your profile information (name, email, phone number) is removed from active use.</li>
            <li>Your saved vehicles and favorite charging locations.</li>
            <li>Your push notification tokens (you will stop receiving notifications).</li>
            <li>Your login sessions are revoked and you are signed out from all devices.</li>
            <li>Your linked Google sign-in / phone OTP credentials with EVeeBuddy.</li>
          </ul>
        </section>

        <section className="mb-10 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <h2 className="text-lg font-semibold">What is retained, and for how long</h2>
          <p className="mt-2 text-sm text-gray-600">
            Some data must be retained for legal, tax, and financial-compliance reasons:
          </p>
          <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm text-gray-700">
            <li>
              <span className="font-medium">Charging session records and wallet transactions</span>
              {' '}— retained for up to 8 years to comply with Indian tax and accounting
              regulations (Income Tax Act and GST law).
            </li>
            <li>
              <span className="font-medium">Tax invoices (GST invoices)</span> — retained for up
              to 8 years as required by Indian GST law.
            </li>
            <li>
              <span className="font-medium">Payment records</span> — retained by our payment
              processor (Cashfree) per RBI / payment-aggregator regulations, independent of our
              systems.
            </li>
            <li>
              <span className="font-medium">Anonymous, aggregated usage data</span> (e.g.
              total sessions per location) that cannot be linked back to you.
            </li>
          </ul>
          <p className="mt-4 text-sm text-gray-600">
            Where records are retained, they are kept in restricted-access systems and used only
            for compliance, audit, fraud-prevention, and dispute-resolution purposes.
          </p>
        </section>

        <section className="mb-10 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <h2 className="text-lg font-semibold">Before you delete</h2>
          <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm text-gray-700">
            <li>Any remaining wallet balance is non-refundable once the account is deleted.</li>
            <li>You will lose access to your charging history and invoices.</li>
            <li>You can create a new account later, but past data cannot be restored.</li>
          </ul>
        </section>

        <footer className="mt-12 border-t border-gray-200 pt-6 text-xs text-gray-500">
          <p>
            Questions? Contact us at{' '}
            <a className="text-[#8bc43e] underline" href={`mailto:${supportEmail}`}>
              {supportEmail}
            </a>
            .
          </p>
          <p className="mt-2">© Pxt Energies Pvt Ltd. EVeeBuddy.</p>
        </footer>
      </main>
    </div>
  );
}
